import EmptyHolder from 'components/EmptyHolder'
import _ from 'lodash'
import React, {useContext} from 'react'
import {NullAsDefault} from 'views/Shared'
import CourseClassContext from '../../CourseClassContext'
import CourseClassSubjects from '../CourseClassSubjects'

const CourseClassSubjectTab = () => {
    const {item, renderWarnings = NullAsDefault} = useContext(CourseClassContext)
    const warnings = Array.from(item?.warnings ?? [])
    const subjects = _.get(item, 'class_subjects', [])

    if (warnings.length) {
        return (
            <div className="w-full flex flex-col gap-3">
                {renderWarnings(warnings)}
            </div>
        )
    }

    return (
        <div className="py-2">
            {subjects.length > 0
                ? <CourseClassSubjects item={item}/>
                : <EmptyHolder style={{border: 'none'}}/>
            }
        </div>
    )
}

export default CourseClassSubjectTab
